import styled from "@emotion/styled";
import { SECONDARY_GREY } from "src/constants/colors";

export const SplitLayoutContainer = styled.div`
  display: flex;
  border-radius: 8px;
  min-height: calc(100vh - 200px);
`;

export const EmailListContainer = styled.div<{ hasSelectedEmail: boolean }>`
  flex: ${(props) => (props.hasSelectedEmail ? "0 0 50%" : "1")};
  min-width: 400px;
  display: flex;
  flex-direction: column;
`;

export const EmailDetailContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const SearchContainer = styled.div`
  flex: 0 0 50%;
  display: flex;
  flex-direction: column;
`;

export const DividerLine = styled.div`
  width: 1px;
  background-color: ${SECONDARY_GREY};
  align-self: stretch;
  min-height: 100%;
  margin: 0px 24px;
`;
